import { Common, Accessors } from "../../../helper";

const classcolumn = [
    
  {
    Header: "",
    accessor: Accessors.Action,
  },
  {
    Header: Common.ClassName,
    accessor: Accessors.Name,
  },
  {
    Header: Common.IsRegistration,
    accessor: Accessors.IsRegistrationGroup,
  },
  {
    Header: Common.Subjects,
    accessor: Accessors.Subjects,
  },
  {
    Header: Common.ClassSize,
    accessor: Accessors.Classsize,
  },
];

export { classcolumn };
